import { post } from '../../../../infra/rest';

export interface deleteChatsResponse {
  deletedChatIds: string[];
  notDeletedChats: {
    chatId: string;
    reason: string;
  }[];
}

export const deleteChats = async (
  chatIds: string[]
): Promise<deleteChatsResponse> => {
  return post<deleteChatsResponse>(
    `/v1/conversation/delete`,
    { body: JSON.stringify({ chatIds }) },
    true
  );
};
